<section class="asset-management-section">
  <ts-page-header [displaySeparationBorder]="true">
    <p page-header-title class="font-ts-header-title text-ts-header-title">Budget</p>
    @if (enableImport) {
      <div page-header-action-buttons>
        <ts-button [matMenuTriggerFor]="menu" [menuIcon]="true" icon="add" variant="primary"> Import </ts-button>
        <mat-menu #menu="matMenu" xPosition="before">
          <ng-container *ngTemplateOutlet="importSources; context: { source: 'yardi' }"></ng-container>
          <ng-container *ngTemplateOutlet="importSources; context: { source: 'sage' }"></ng-container>
          <ng-container *ngTemplateOutlet="importSources; context: { source: 'entrata' }"></ng-container>
        </mat-menu>
      </div>
    }

    <div page-header-action-bar class="w-full flex flex-row items-center justify-start gap-2">
      <ts-input
        size="sm"
        placeholder="Filter accounts"
        icon="ts_search"
        class="max-w-1/4"
        clearable="true"
        [formControl]="budgetFormFilter"
      ></ts-input>
      <report-period-selector
        [loading]="loading()"
        [reportPeriod]="reportPeriod()"
        (reportPeriodChanged)="reportPeriodChanged.next($event)"
      />
    </div>
  </ts-page-header>

  <ts-table
    [autoHeight]="false"
    [rowData]="filteredBudgetRowData()"
    [columnDefs]="propertyBudgetColDefs()"
    [loading]="loading()"
  ></ts-table>
</section>

<ng-template #importSources let-source="source">
  <input
    hidden
    type="file"
    accept=".pdf, .xls, .xlsx"
    #fileInput
    (change)="this.importBudget.emit({ file: $event?.target?.files[0], source: source })"
  />
  <button mat-menu-item (click)="fileInput.click()">{{ source | titlecase }}</button>
</ng-template>
